import { LabelWithControl } from "components/common/LabelControl";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import clsx from "clsx";
import { useEffect } from "react";
import { IndividualHeader } from "./IndividualHeader";

export const AmendPoHeader = ({
  data,
  rounding,
  overseas,
  handball,
  setAmendItems,
}) => {
  useEffect(() => {
    if (
      data &&
      (rounding !== undefined ||
        overseas !== undefined ||
        handball !== undefined)
    ) {
      setAmendItems((prevItems) => {
        const updatedItems = prevItems.map((item) => ({
          ...item,
          isQuantityRounded: rounding,
          isOverseas: overseas,
          isHandball: handball,
        }));

        return JSON.stringify(updatedItems) !== JSON.stringify(prevItems)
          ? updatedItems
          : prevItems;
      });
    }
  }, [rounding, data, overseas, handball]); //eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className={clsx("poHeaderStyling")}>
      <Grid sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <Box
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
            },
          }}
        >
          {/* Labels Row */}
          <Grid container spacing={1} sx={{ "& > *": { flex: 1 } }}>
            <Grid item xs={12} sm={6} md={3}>
              <LabelWithControl label="PO Identifier" />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl label="Order Date" />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl label="Delivery Date" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Total Cases" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Total Pallets" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Total Bases" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Total Wagons" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Comments" />
            </Grid>
          </Grid>
        </Box>
        {data && data.length > 0 && (
          <IndividualHeader items={data} setAmendItems={setAmendItems} />
        )}
      </Grid>
    </div>
  );
};
